module.exports = __webpack_public_path__ + "img/steel-7.014a289c.jpg";